import { Timestamp } from '@angular/fire/firestore';
import { IAdvancedFilterGroup } from '../../../features/settings-new/models/general/advanced-filter-group.interface';
import { StockTakePopulationSortOrder } from './stock-take-population-sort.enum';

export type ScheduleFrequency = 'daily' | 'weekly' | 'monthly';

/**
 * A single scheduled stock take entry stored in Firestore.
 */
export interface IStockTakeScheduleEntry {
  /** When this schedule was created */
  createdAt: Timestamp;
  /**
   * @deprecated Use filterGroups. Kept for backward compatibility with single-filter schedules.
   * The saved advanced filter group that determines which stock items to include.
   */
  filterGroup: IAdvancedFilterGroup | null;
  /** How often this schedule runs */
  frequency: ScheduleFrequency;
  /** Whether this schedule is active and should be included when running */
  isActive: boolean;
  /** Display name for the scheduled stock take */
  name: string;
  /** For monthly frequency: day of the month (1–31) */
  dayOfMonth?: number;
  /**
   * @deprecated Use frequency + selectedDays instead.
   * Kept for backward compatibility with existing Firestore data.
   */
  dayOfWeek?: number;
  /** Optional description / notes */
  description?: string;
  /** Saved advanced filter groups combined with OR when multiple are selected. */
  filterGroups?: IAdvancedFilterGroup[];
  /** Sort order when populating items from the configured filter(s). */
  filterSortOrder?: StockTakePopulationSortOrder;
  id?: string;
  /**
   * Max list items to add when the schedule runs (oldest last-stock-take first), capped at 500.
   */
  itemLimit?: number;
  /** Set by FE when a stock take created from this schedule is processed (status → SUBMITTED). */
  lastRunAt?: Timestamp;
  /** For weekly/custom frequency: days of week (0=Sun, 1=Mon ... 6=Sat) */
  selectedDays?: number[];
}
